/**
 * App shell header. Wallet connection lives inside the LI.FI widget (EVM, Solana and
 * Tron), so this only carries branding — see `providers` in App.tsx.
 */
export function Header() {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-white/10 bg-background/30 backdrop-blur-2xl">
      <div className="container relative z-10 flex h-16 items-center justify-between px-4">
        <a href="/" className="group flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-primary to-cyan-400 text-primary-foreground shadow-lg shadow-primary/20 transition-transform group-hover:scale-105">
            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none">
              <path
                d="M5 9h11l-3-3m6 6H8l3 3"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="hidden leading-tight sm:block">
            <p className="text-sm font-bold">Swap</p>
            <p className="text-[10px] font-medium text-muted-foreground uppercase tracking-tight">
              Aggregator
            </p>
          </div>
        </a>
      </div>
    </header>
  );
}
